
import { useState } from "react";
import styles from "./Table.module.scss"

const Table = ({data}) => {
    const [counter, setCounter] = useState(1);
    return (
        <table className={styles.tableContainer}>
            <thead>
            <tr className={styles.tableHeader}>
                <th>Категория</th>
                <th>ФИО участника</th>
                <th>Баллы</th>
                {/*<th>Место</th>*/}
            </tr>
            </thead>
            <tbody>
            {data?.teams?.map((team, index) => (
                
                <tr key={index} className={styles.a}>
                    <td className={styles.tableElement}>{team.purpose.name}</td>
                    {/*<td style={{textAlign: 'start'}} className={styles.tableElement}>{team.purpose.name} <a target="_blank" style={{textDecoration: 'underline'}} href={team.team_media.image}>(посмотреть видео)</a></td>*/}
                    <td  className={styles.tableElement}>{team.participants[0].user.name}</td>
                    <td className={styles.tableElement}>{team.votes_count}</td>
                    {/*<td className={styles.tableElement}> {index < 3 ? index + 1 : ''}</td>*/}
                </tr>
            ))}
            </tbody>
        </table>
    );
};

export {Table}